import { type CleaningOrder } from './api/types'

export const formatDate = (dateString: string): string => {
	const date = new Date(dateString)
	return date.toLocaleDateString('cs-CZ', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	})
}
export const formatDateWithWeekday = (dateString: string): string => {
	const date = new Date(dateString)
	return date.toLocaleDateString('cs-CZ', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
		weekday: 'long',
	})
}

export const formatTime = (dateString: string): string => {
	const date = new Date(dateString)
	return date.toLocaleTimeString('cs-CZ', {
		hour: '2-digit',
		minute: '2-digit',
	})
}

export const findClosestFutureDateIndex = (dates: string[]): number => {
	const now = new Date()
	let closestIndex = -1
	let closestDateDiff = Infinity

	dates.forEach((date, index) => {
		const dateObj = new Date(date)
		const diff = dateObj.getTime() - now.getTime()

		if (diff > 0 && diff < closestDateDiff) {
			closestDateDiff = diff
			closestIndex = index
		}
	})

	return closestIndex
}

export const findClosestOrder = (orders: CleaningOrder[]) => {
	const ordersDates = orders.map(order => order.date)
	const nextIndex = findClosestFutureDateIndex(ordersDates)
	if (nextIndex !== -1) return orders[nextIndex]
	return null
}
